import React from "react"
import PropTypes from "prop-types"
import { Link, BrowserRouter as Router } from "react-router-dom"

// Components
import HorizontalScoreBar from "../HorizontalScoreBar/HorizontalScoreBar"
import resizeComponent from "../ResizeComponent/ResizeComponent"

// Resizable Components
const ResizableHorizontalScoreBar = resizeComponent(HorizontalScoreBar)

const TableRow = props => {
  const { keys, person, rowSpacing } = props

  return (
    <div className="scores-tr d-flex" key={`tr-${person.elevate_person_id}`}>
      {keys.map(key =>
        key === "riskScore" ? (
          <div
            key={`score-${person.elevate_person_id}`}
            style={{ ...rowSpacing }}
            className="scores-td d-flex justify-content-center scorebar margin-right-5"
          >
            <div
              className="h-100"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div style={{ width: "20%" }}>{person.riskScore}</div>
              <div style={{ width: "70%" }}>
                <ResizableHorizontalScoreBar score={person.riskScore} />
              </div>
            </div>
          </div>
        ) : key === "name" ? (
          <div
            key={`${key}-${person.elevate_person_id}`}
            style={rowSpacing}
            className="scores-td d-flex justify-content-center text-truncate margin-right-5"
          >
            {person.is_manager ? (
              <Router>
                <Link
                  to={`/engagement/vision2/insights/team/${person.elevate_person_id}`}
                >
                  <div className="text-truncate py-1">{person.name}</div>
                </Link>
              </Router>
            ) : (
              <p className="text-truncate mr-2 mb-0">{person.name}</p>
            )}
          </div>
        ) : (
          <div
            key={`${key}-${person.elevate_person_id}`}
            style={rowSpacing}
            className="scores-td d-flex justify-content-center text-truncate margin-right-5"
          >
            <p className="text-truncate mb-0 person-key">{person[key]}</p>
          </div>
        )
      )}
    </div>
  )
}

export default TableRow

TableRow.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  person: PropTypes.shape({
    elevate_person_id: PropTypes.string,
    name: PropTypes.string,
    riskScore: PropTypes.number,
    department: PropTypes.string,
    is_manager: PropTypes.bool
  }).isRequired,
  rowSpacing: PropTypes.shape({
    flex: PropTypes.string,
    minWidth: PropTypes.string
  }).isRequired
}
